import Vue from 'vue';
import App from './app.vue';
//import iView from 'iview';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import {router} from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import BaiduMap from 'vue-baidu-map';
import myAbp from './lib/myAbp';

Vue.use(myAbp);

Vue.use(ViewUI,{
  size:'small',
  modal: {
    maskClosable:false
  }
});
Vue.use(BaiduMap,{
  ak: 'WOPNuwKcQ0fZr5jmlwwbGMOHdEcQNui0'
})
import store from './store/index';
Vue.config.productionTip = false;
import { appRouters,otherRouters} from './router/router';
if(!abp.utils.getCookieValue('Abp.Localization.CultureName')){
  let language=navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName',language,new Date(new Date().getTime() + 5 * 365 * 86400000),abp.appPath);
}

Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{
  Util.abp=Util.extend(true,Util.abp,data.data.result);
  new Vue({
    render: h => h(App),
    router:router,
    store:store,
    data: {
      currentPageName: ''
    },
    async mounted () {
      this.currentPageName = this.$route.name as string;
      await this.$store.dispatch({
        type:'session/init'
      })
      await this.$store.dispatch({
        type:'common/init'
      })
      if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
            SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit('app/initCachepage');
      this.$store.commit('app/updateMenulist');
      //设置关键字
      //document.querySelector('meta[name="keywords"]').setAttribute('content', Util.abp.setting.get('App.SiteConfig.KeyWords'));
      //document.querySelector('meta[name="description"]').setAttribute('content', Util.abp.setting.get('App.SiteConfig.Description'));
      document.dispatchEvent(new Event('render-event'));
    },
    created () {
      let tagsList:Array<any> = [];
      appRouters.map((item) => {
          if (item.children.length <= 1) {
              tagsList.push(item.children[0]);
          } else {
              tagsList.push(...item.children);
          }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})

